import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProductTableModel } from 'src/app/models/table-models/product-table';
import { PosProductsModalComponent } from 'src/app/shared/pos-products-modal/pos-products-modal.component';
import { ModalDialogType } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PosProductsModalService {

  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService) {


  }

  show(confirmAction: (product: ProductTableModel) => any) {
    return new Promise(async (resolve, reject) => {
      this.modalRef = this.modalService.show(PosProductsModalComponent,
        {
          ignoreBackdropClick: true
        })
      this.modalRef.setClass(`modal-dialog ${ModalDialogType.PRIMARY} modal-lg`)
      this.modalRef.content.confirmAction = confirmAction;
      resolve(true);
    })
  }

  hide() {
    this.modalRef?.hide();
  }
}
